import { DataTableDesignTokens } from '@primeuix/themes/types/datatable';
import { colors } from '../colors';

export const datatable: DataTableDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        borderColor: colors.border,
      },
      headerCell: {
        background: '{blue.400}',
        color: colors.textWeak,
        hoverBackground: '{blue.300}',
        selectedBackground: '{blue.300}',
      },
      row: {
        background: '{blue.500}',
        color: colors.textWeak,
        hoverBackground: '{blue.400}',
        selectedBackground: '{blue.400}',
      },
      filter: {
        overlaySelect: {
          background: '{blue.300}',
          borderColor: colors.border,
        },
        overlayPopover: {
          background: '{red.300}',
          borderColor: colors.border,
        },
      },
    },
  },
};
